import {
  updateDoc,
  doc
} from 'firebase/firestore';
import { db } from '../config/firebase';

export const userService = {
  // Note: User profile reading is now handled by DataStoreContext for real-time updates
  // This service now focuses on mutations and complex operations

  // Update user profile
  async updateUserProfile(userId, profileData) {
    const docRef = doc(db, 'users', userId);
    await updateDoc(docRef, {
      ...profileData,
      updatedAt: new Date()
    });
  },

  // Note: User statistics, leaderboard, and vote queries are now handled by DataStoreContext
  // for better performance using in-memory data and real-time updates

  // Note: User profile subscriptions are now handled by DataStoreContext
  // Use dataStore.getUser(userId) for real-time user profile data
};

export default userService;
